import { PlayersSelector as PlayersSelectorComponent } from './PlayersSelector.component';
import { connector } from './PlayersSelector.connector';
export const PlayersSelector = connector(PlayersSelectorComponent);
